import { Box } from '@mui/material'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { IFolder } from '../../../../api/FolderApi'
import { TOKENS } from '../../../../pages/dashboard-v2/components/primitives'
import { getFolderName } from '../../../../util/getFolderName'

// The folder path of the new design: "Home › Filialen › Nord" as pills like the folder chips below,
// every part clickable except the current folder (replaces the grey chips of FolderBreadCrumbs).
export default function FolderPath({ folder, onNavigation }: { folder: IFolder, onNavigation: (folder: IFolder) => void }) {
  const { t } = useTranslation()
  const parents: IFolder[] = []
  let { parent } = folder
  while (parent) {
    parents.push(parent)
    parent = parent.parent
  }
  parents.reverse()

  const pill = {
    display: 'inline-flex', alignItems: 'center', gap: 0.75, height: 30, px: 1.5, borderRadius: '999px',
    border: '1px solid #C3CCD8', bgcolor: '#FFFFFF', color: TOKENS.text, fontSize: 13, fontWeight: 600, boxSizing: 'border-box'
  } as const
  // the top folder is "Home": house instead of folder icon
  const icon = (f: IFolder, current = false) => (
    <i
      className={!f.parent ? 'fas fa-house' : (current ? 'fas fa-folder-open' : 'fas fa-folder')}
      style={{ fontSize: 12, color: current ? '#FFFFFF' : TOKENS.primary }}
      aria-hidden
    />
  )

  return (
    <Box
      component="nav"
      aria-label={t('processList.folderPath')}
      sx={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75, fontSize: 13, color: TOKENS.muted
      }}
    >
      {parents.map((p) => (
        <Fragment key={p.id}>
          <Box
            component="button"
            type="button"
            onClick={() => onNavigation(p)}
            sx={{ ...pill, cursor: 'pointer', font: 'inherit', fontWeight: 600, '&:hover': { bgcolor: '#F4F6F9' } }}
          >
            {icon(p)}
            {getFolderName(p, t)}
          </Box>
          <span aria-hidden>›</span>
        </Fragment>
      ))}
      <Box
        component="span"
        sx={{ ...pill, bgcolor: TOKENS.text, borderColor: TOKENS.text, color: '#FFFFFF' }}
        aria-current="page"
      >
        {icon(folder, true)}
        {getFolderName(folder, t)}
      </Box>
    </Box>
  )
}
